import { render } from "./tour-booked.vue?vue&type=template&id=aef98d80&scoped=true"
import script from "./tour-booked.vue?vue&type=script&lang=js"
export * from "./tour-booked.vue?vue&type=script&lang=js"

import "./tour-booked.vue?vue&type=style&index=0&id=aef98d80&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef98d80"]])

export default __exports__